var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useMemo } from 'react';
import { RestaurantIllustration } from '@deliveryhero/armor-illustrations';
import { HeaderNavigationMenuContent, HeaderNavigationMenuContentBody, HeaderNavigationMenuContentHeader } from '@deliveryhero/armor';
var menuContentBodyOptions = [{
  value: 'arara',
  label: 'Arara',
  url: '/dashboard/arara/'
}, {
  value: 'rooster',
  label: 'Rooster',
  url: '/dashboard/rooster/'
}, {
  value: 'dps',
  label: 'Dynamic Pricing Service',
  url: ''
}, {
  value: 'porygon',
  label: 'Delivery Area Service',
  url: '/dashboard/deliveryareas/'
}, {
  value: 'tweety',
  label: 'Tweety',
  url: '/dashboard/tweety/'
}, {
  value: 'tes',
  label: 'Time Estimation Service',
  url: '/'
}, {
  value: 'hurrier',
  label: 'Hurrier',
  url: '/'
}, {
  value: 'cod',
  label: 'Cash collection',
  url: '/dashboard/cash-collection/'
}, {
  value: 'ice',
  label: 'Issue Customization Engine',
  url: '/dashboard/ice/'
}];
var onOptionSelect = function onOptionSelect(item) {
  if (window && item.url) {
    window.location.assign(item.url);
  }
};
export var HeaderNavigationMenuContentLogistics = function HeaderNavigationMenuContentLogistics(_a) {
  var displayedApplicationCodes = _a.displayedApplicationCodes,
    restProps = __rest(_a, ["displayedApplicationCodes"]);
  var items = useMemo(function () {
    if (!displayedApplicationCodes) {
      return menuContentBodyOptions;
    }
    return menuContentBodyOptions.filter(function (application) {
      return displayedApplicationCodes.find(function (code) {
        return code.includes(application.value);
      });
    });
  }, [menuContentBodyOptions, displayedApplicationCodes]);
  return React.createElement(HeaderNavigationMenuContent, Object.assign({}, restProps), React.createElement(HeaderNavigationMenuContentHeader, {
    label: "Logistics",
    image: React.createElement(RestaurantIllustration, {
      height: "42px",
      width: "42px"
    })
  }), React.createElement(HeaderNavigationMenuContentBody, {
    options: items,
    onOptionSelect: onOptionSelect
  }));
};